'use client';
// Every horizontal strip on the page scrolls with a mouse drag and the vertical wheel (round 6, 28/10/26 Founder: review photos, review
// cards, filter chips, gallery sliders, the assistant's chips/cards) — one attach per strip (lib/useDragScroll attachDragScroll, idempotent,
// so strips that already use the hook are skipped). Strips mount late (lazy sections, assistant), so a MutationObserver re-scans.
import { useEffect } from 'react';
import { attachDragScroll } from '@/lib/useDragScroll';

const STRIPS = '.rv-slider,.rvf-chips,.pm-gal-slider .grid,.pdl-gal-slider .pdl-gal-grid .grid,.ct2a-chips,.ct2a-cards,.tp-sl';

export default function HStripScroll() {
  useEffect(() => {
    const done = new Map<HTMLElement, () => void>();
    const scan = () => {
      for (const [el, off] of done) if (!el.isConnected) { off(); done.delete(el); }
      document.querySelectorAll<HTMLElement>(STRIPS).forEach((el) => {
        if (done.has(el) || el.dataset.dragScroll || getComputedStyle(el).overflowX === 'visible') return;
        done.set(el, attachDragScroll(el));
      });
    };
    scan();
    let t: ReturnType<typeof setTimeout> | null = null;
    const mo = new MutationObserver(() => { if (!t) t = setTimeout(() => { t = null; scan(); }, 250); });
    mo.observe(document.body, { childList: true, subtree: true });
    return () => { mo.disconnect(); if (t) clearTimeout(t); for (const off of done.values()) off(); };
  }, []);
  return null;
}
